import { render, staticRenderFns } from "./FormResearch2.vue?vue&type=template&id=b2cc9608&scoped=true"
import script from "./FormResearch2.vue?vue&type=script&lang=js"
export * from "./FormResearch2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cc9608",
  null
  
)

export default component.exports